module.exports = __webpack_public_path__ + "static/media/search.55473c27.svg";